import React from "react";
import "./rewardmanagement.css";
import { Container } from "react-bootstrap";

const RewardManagement = () => {
  return (
    <Container className="py-5 reward-management">
      <h2 className="section-title">Reward Management System</h2>
      <p className="lead">
        Cloud 10 provides a data-first loyalty ecosystem purpose-built for the
        modern hospitality industry. More than just a rewards engine, it is a
        dynamic engagement platform that leverages advanced analytics to deepen
        emotional connections, drive brand love, and transform guest behavior
        into lifelong loyalty.
      </p>

      <h4 className="subheading">
        🧠 Core Features Powered by Data Intelligence:
      </h4>
      <ul className="feature-list">
        <li>
          <strong>Dynamic Tiering System:</strong> Build flexible loyalty tracks
          informed by guest frequency, spend patterns, and engagement
          metrics—rewarding not just bookings, but genuine brand affinity.
        </li>
        <li>
          <strong>Adaptive Rewards Engine:</strong> Use AI insights to
          recommend, adjust, and optimize rewards in real-time. Offer
          high-impact redemption options that align with individual guest value
          and preferences.
        </li>
        <li>
          <strong>Behavioral Personalization:</strong> Tap into machine learning
          models that analyze stay history, purchase behavior, and sentiment to
          auto-trigger custom perks—birthday surprises, upgrade invitations, or
          personalized packages.
        </li>
        <li>
          <strong>Multi-Touchpoint Integration:</strong> Collect and respond to
          behavioral signals across every channel: mobile, web, in-property, or
          voice. Feed these signals back into the system to continuously tailor
          future experiences.
        </li>
      </ul>

      <h4 className="subheading mt-5">📊 Data-Driven Advantages:</h4>
      <ul className="feature-list">
        <li>
          <strong>Predictive Loyalty Modeling:</strong> Forecast guest value and
          retention likelihood using historical and real-time data.
        </li>
        <li>
          <strong>Intelligent Segmentation:</strong> Build micro-audiences on
          the fly for laser-focused loyalty campaigns.
        </li>
        <li>
          <strong>Live ROI Tracking:</strong> See how every tier adjustment,
          promotion, or partner reward impacts revenue and guest satisfaction.
        </li>
        <li>
          <strong>Continuous Optimization Loop:</strong> The system learns what
          works and iterates to boost performance across your portfolio.
        </li>
      </ul>
    </Container>
  );
};

export default RewardManagement;
